import fetch from '@/common/utils/serFetch'
import { GATEWAYSER } from '@/common/config'
import { GATEWAY } from '@/common/config/index'

const moduleList = {
  serviceProvider: `${GATEWAYSER.SQSIM}/serviceProvider`,
  customerStaffManager: `${GATEWAYSER.SQSIM}/customerStaffManager`,
  workOrderTypeWKD: `${GATEWAYSER.BPO}/workOrderType`, // 问题类型 小前台
  ruleModel: `${GATEWAYSER.SQSQT}/ruleModel`, // 模型管理
  skillGroup: `${GATEWAYSER.SQSIM}/skillGroup`, // 飞兔
  selector: `${GATEWAYSER.SQSQT}/selector`
}

export const publicApi = {
  // 列表页
  reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/page`, reqData),
  // 一级问题类型
  getFirstTypeUrl() {
    return fetch.get(`${moduleList.workOrderTypeWKD}/list/workOrderFirstType?isEnable=1`)
  },
  // 二级问题类型
  getSecondTypeUrl() {
    return fetch.get(`${moduleList.workOrderTypeWKD}/list/workOrderSecondType?isEnable=1&firstId=`)
  },
  // 模型
  reqModelList: reqData => fetch.post(`${moduleList.ruleModel}/page`, reqData),
  // 渠道
  reqDitch(params) {
    return fetch.post(`${moduleList.skillGroup}/page`, params)
  },
  // 人工复检人员 / 人工复检人员
  reqPersonnel: `/basicdata/sysUser/queryByPage?networkId=22&name={{key}}&current={{current}}&size={{size}}`,
  // 详情
  reqDetail: id => fetch.get(`${GATEWAYSER.SQSQT}/task/get?id=${id}`),
  // 分配
  reqAllocation: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/assign`, reqData),
  // 工质检提交
  reqRecheck: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/recheck`, reqData),
  // 申诉提交
  reqAppeal: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/appeal`, reqData),
  // 脱敏
  reqPhone: id => fetch.get(`${GATEWAYSER.SQSQT}/task/phone/decrypt?id=${id}`),
  // 列表脱敏字段解密
  decrypt: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/decrypt`, reqData),
  // 模型分类下拉数据
  reqGroup: reqData => fetch.post(`${GATEWAYSER.SQSQT}/ruleModelGroup/list`, reqData),
  // 编辑
  reqRecheckEdit: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/retest`, reqData),
  // 批量质检
  reqBatch: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/recheck/batch`, reqData),
  // 获取录单二级类型
  getSecondType({ id, waybillNo, historyType = 1 }) {
    return fetch.get(`${moduleList.workOrderTypeWKD}/list/transferWorkOrderSecondTypes?isEnable=1&firstId=${id}&waybillNo=${waybillNo}&historyType=${historyType}`)
  },
  // 服务商
  queryProvider() {
    return fetch.get(`${moduleList.selector}/im/serviceProvider`)
  },
}

// 列表页请求
export const reqApiObj = {
  // 质检结果
  1: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/result/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/result/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/result/export/fileUrl`
  },
  // 质检任务管理-在线质检
  2: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/export/fileUrl`
  },
  // 质检任务管理-语音质检
  8: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/cc/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/export/fileUrl`
  },
  // 质检任务管理-工单质检
  11: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/wo/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/export/fileUrl`
  },
  // 质检任务待处理
  3: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/handleWaiting/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/handleWaiting/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/handleWaiting/export/fileUrl`
  },
  // 质检任务已处理
  4: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/handleProcessed/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/handleProcessed/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/handleProcessed/export/fileUrl`
  },
  // 申诉任务管理-在线质检申诉
  5: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/appeal/export/fileUrl`
  },
  // 申诉任务管理-语音质检申诉
  9: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/cc/appeal/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/appeal/export/fileUrl`
  },
  // 申诉任务管理-工单质检申诉
  10: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/wo/appeal/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/appeal/export/fileUrl`
  },
  // 申诉任务待处理
  6: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/handleWaiting/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/handleWaiting/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/appeal/handleWaiting/export/fileUrl`
  },
  // 申诉任务已处理
  7: {
    reqList: reqData => fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/handleProcessed/page`, reqData),
    reqExcel(reqData) {
      return fetch.post(`${GATEWAYSER.SQSQT}/task/manage/appeal/handleProcessed/export/adaptive`, reqData, { handle: true, responseType: 'arraybuffer' }).then(res => res)
    },
    fileUrl: `${GATEWAYSER.SQSQT}/task/manage/appeal/handleProcessed/export/fileUrl`
  }
}

// 工单管理 => 分配管理
export const reqUserList = str => {
  return fetch.get(`/basicdata/sysUser/queryByPage?${str}isEnable=1`)
}

// 工单管理 => 分配管理 客服分配新接口
export const reqNewUserList = str => {
  return fetch.get(`${GATEWAY.SER}/customer/queryCustomerByConfig?${str}isEnable=1`)
}

// 工单管理 => 分配网点
export const distributionList = str => {
  return fetch.get(`${GATEWAY.SER}/network/pageAllNextDetailById?${str}`)
}
// 工单管理 => 分配网点（新接口）
export const distributionListNew = str => {
  return fetch.get(`${GATEWAY.SER}/customer/assign/network?${str}`)
}
